import { ReactComponent as UploadIcon } from '../../../../assets/upload_file.svg'

type FileSelectorProps = {
  selectedFile: File | null
  setSelectedFile: (file: File | null) => void
}

export const FileSelector = ({
  selectedFile,
  setSelectedFile,
}: FileSelectorProps) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0]
      if (file.size <= 25 * 1024 * 1024) {
        // 25MB limit
        setSelectedFile(file)
      } else {
        alert('File size exceeds 25MB limit')
      }
    }
  }

  return (
    <div className='flex flex-col min-h-[67px] w-full mb-2'>
      {selectedFile ? (
        <div className='flex flex-row justify-between'>
          <p className='text-body2 text-gray-500'>
            Selected file: {selectedFile.name}
          </p>
          <button onClick={() => setSelectedFile(null)}>Remove</button>
        </div>
      ) : (
        <>
          <p className='text-black text-[14px] font-medium mb-1'>
            * Upload document (or enter a URL below)
          </p>
          <div
            className='flex items-center gap-1 cursor-pointer mb-2'
            onClick={() => document.getElementById('file-upload')?.click()}
          >
            <UploadIcon />
            <div>
              <p className='text-primary'>Click to upload a file</p>
              <p className='text-caption text-gray-500'>
                DOC., DOCX. (25 MB limit)
              </p>
            </div>
            <input
              id='file-upload'
              type='file'
              hidden
              onChange={handleFileChange}
              accept='.doc,.docx'
            />
          </div>
        </>
      )}
    </div>
  )
}
